import React from 'react';

import SidepanelItem from 'nav/sidepanel/listing/SidepanelItem';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {apiIdToIconName} from 'util/APIUtil';
import {capitalize} from 'util/NameUtil';
import {worklistTypeDisplayName} from 'worklists/WorklistConstants';
import {formatWorklistDate} from 'worklists/WorklistUtil';

import {WorklistSummaryGraphQL} from '../../../graphql-fragments/worklists/__generated/WorklistSummaryGraphQL';

export interface WorklistsSidepanelListProps {
  worklists: Array<WorklistSummaryGraphQL> | null;
  isCompact: boolean;
  onOpenWorklist: (worklistSummary: WorklistSummaryGraphQL) => void;
}

export default function WorklistsSidepanelList(props: WorklistsSidepanelListProps): JSX.Element {
  if (props.worklists == null) {
    return <CenteredHorizontalThrobber />;
  }

  if (props.worklists.length === 0) {
    return <div className="sidepanel-fadedMessage">No worklists found.</div>;
  }

  return (
    <div>
      {props.worklists.map((worklist) => (
        <WorklistSidepanelRow
          onClick={() => {
            props.onOpenWorklist(worklist);
          }}
          key={worklist.id}
          worklist={worklist}
          isCompact={props.isCompact}
          isChild={false}
        />
      ))}
    </div>
  );
}

export interface WorklistSidepanelRowProps {
  worklist: WorklistSummaryGraphQL;
  isCompact: boolean;
  onClick: () => void;
  isChild: boolean;
}

export const WorklistSidepanelRow: React.FunctionComponent<WorklistSidepanelRowProps> = (
  props: WorklistSidepanelRowProps
): JSX.Element => {
  const dateString = formatWorklistDate(props.worklist.modifiedAt, props.isCompact);
  return (
    <SidepanelItem
      active={false}
      className="sidepanelItem--noIcon"
      faded={false}
      icon={<BenchlingIcon icon={apiIdToIconName(props.worklist.id)} />}
      isCompact={props.isCompact}
      onClick={props.onClick}
      showStar={false}
      starred={false}
      subTitle={dateString}
      title={{text: props.worklist.name, node: <WorklistSidepanelTitle worklist={props.worklist} />}}
      isExpandable={false}
      isChild={props.isChild}
    />
  );
};

function WorklistSidepanelTitle(props: {worklist: WorklistSummaryGraphQL}): JSX.Element {
  return (
    <span>
      <span className="sidepanel-primaryLabel">{props.worklist.name}</span>
      <span className="sidepanel-secondaryLabel">
        {' '}
        {capitalize(worklistTypeDisplayName(props.worklist.itemType))}
      </span>
    </span>
  );
}
